import { APP } from '../enums';
import { injectedPlatform } from '../globals/ConfigureGlobals';

export const isAndroid = () => injectedPlatform?.OS === APP.PLATFORM.ANDROID;
